var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echarts"},[_c('div',{ref:"chartContainer",attrs:{"id":"datasets"}}),_c('div',{staticClass:"name"},[_vm._v("Five Property Datasets")])])
}
var staticRenderFns = []

export { render, staticRenderFns }